import React from 'react';
import { TextProps } from '../common/Text/styles';
import { Text } from '../common/Text/Text';
import { CheckIcon } from '../../../icons';

export interface StepProps {
    state: 'selected' | 'completed' | 'disable';
    count: '1' | '2' | '3';
    name: 'Gift Amount' | 'Gift Purpose' | 'Gift Summary';
    onClick?: (count: StepProps['count'], name: StepProps['name']) => unknown;
}

const getColor = (state: StepProps['state']): TextProps['color'] => {
    switch (state) {
        case 'completed':
        case 'selected':
            return 'primaryGuidingViolet';
        case 'disable':
            return 'utilityInputColor';
    }
};

export const Step: React.FC<StepProps> = ({ state, count, name }) => {
    const color = getColor(state);
    const borderClass =
        state === 'selected' ? 'border-guiding-violet' : 'border-utility-input';
    return (
        <div className="flex items-center cursor-default">
            <Text
                variant={'large'}
                className={`circled mr-4 flex h-12 w-12 cursor-default items-center justify-center rounded-full border-2 border-solid transition-[border,color] duration-1000 ease-[ease] ${borderClass}`}
                color={color}
                weight={'extraBold'}
            >
                <span className="-mb-0.5">
                    {state === 'completed' ? <CheckIcon /> : count}
                </span>
            </Text>
            <Text
                variant={'medium'}
                className="name cursor-default transition-[color] duration-1000 ease-[ease]"
                color={color}
                weight={'extraBold'}
            >
                {name}
            </Text>
        </div>
    );
};
